/**
 * Fisher–Yates shuffle
 * https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
 */
export const shuffle = (array: any[]): any[] => {
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;

    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];

        array[currentIndex] = array[randomIndex];

        array[randomIndex] = temporaryValue;
    }

    return array;
};

type CompareElement = string | number | boolean;

const prepareToCompare = (value: CompareElement): string | number | boolean => {
    if (typeof value === 'string') {
        return value.toString().toUpperCase();
    }
    return value;
};

export const sortAsc = <T extends CompareElement | null>(a: T, b: T): 1 | -1 => {
    if (a === null) return 1;
    if (b === null) return -1;
    return prepareToCompare(a) > prepareToCompare(b) ? 1 : -1;
};

export const sortDesc = <T extends CompareElement | null>(a: T, b: T): 1 | -1 => {
    if (a === null) return 1;
    if (b === null) return -1;
    return prepareToCompare(a) > prepareToCompare(b) ? -1 : 1;
};

export const uniqueStrings = <TValue extends string>(values: TValue[]): TValue[] => [...new Set(values)];
